






















































import { Component, Vue, Mixins, Prop } from "vue-property-decorator";
// api
import { createRecharge, updateRecharge } from "@/api/recharge";
import { AddRecharge } from "@/types/api/recharge";
// 工具
import print from "@/utils/print";

@Component
export default class Table extends Vue {
  @Prop() dialogVisible!: boolean;
  @Prop() form!: AddRecharge;
  @Prop() type!: string;

  ruleForm: string = "ruleForm";
  // 规则
  rules: any = {
    chargeAmount: [
      { required: true, message: "请输入充值方案数额", trigger: "blur" },
    ],
    giveAmount: [
      { required: true, message: "请输入赠送养身元", trigger: "blur" },
    ],
    experiencePoint: [
      { required: true, message: "请输入赠送会员值", trigger: "blur" },
    ],
  };

  // 关闭对话框
  close() {
    this.$emit("close");
  }
  // 确认提交
  confirm() {
    let ref: any = this.$refs;
    ref[this.ruleForm].validate((valid: any) => {
      // 校验成功
      if (valid) {
        let prom: any;
        if (this.type == "add") {
          prom = createRecharge(this.form); // 添加
        } else {
          prom = updateRecharge(this.form); // 修改
        }
        prom.then((res: any) => {
          this.$message.success("提交成功");
          this.$emit("getData");
          this.close();
        });
      } else {
        return false;
      }
    });
  }
}
